import { render, staticRenderFns } from "./Strut2000-H.vue?vue&type=template&id=30b45e6a"
import script from "./Strut2000-H.vue?vue&type=script&lang=js"
export * from "./Strut2000-H.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports